export default "__VITE_ASSET__DIMPcL2E__"